import { getPortalSdk } from 'portal-sdk';

import { CURRENT_MIGRATION_VERSION } from 'src/reducers/migrations/constants';
import { Project } from 'src/store/state/projects';
import { encodeCloudStorageProject } from 'src/utils/exportProject/encodeProject';
import { getCloudProjectListQueryKey } from 'src/utils/hooks/useCloudStorageProjects';
import { queryClient } from 'src/utils/queryClient';

export const duplicateProjectToCloud = async (project: Project) => {
  const portalSdk = getPortalSdk();

  const newProject = encodeCloudStorageProject(
    project,
    CURRENT_MIGRATION_VERSION
  );
  if (newProject && portalSdk) {
    const newProjectId = await portalSdk?.createDesignerProject(
      project.name,
      newProject,
      project.connectionId
    );
    if (newProjectId) {
      queryClient.refetchQueries(getCloudProjectListQueryKey());
    }
    return newProjectId;
  }

  return null;
};
